/**
 * @group Functions
 * 
 * @summary
 * <blockquote>Maps error codes to appropriate HTTP status codes</blockquote>
 * 
 * @param {string} code - Error code to map to HTTP status code
 * @returns {HttpStatusCode} The corresponding HTTP status code
 * 
 * @example
 * ```typescript
 * getStatusCodeForErrorCode("BAD_GATEWAY");        // 502
 * getStatusCodeForErrorCode();                     // 500
 * ```
 */
import { HTTP_STATUS_CODES, type HttpStatusCode, type HttpStatusCodeKey } from '@shared/constants';

export function getStatusCodeForErrorCode(code?: string): HttpStatusCode {
  if (!code) {
    return HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR;
  }

  const key = code.toUpperCase() as HttpStatusCodeKey;
  return HTTP_STATUS_CODES[key] ?? HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR;
} 